// extracted by mini-css-extract-plugin
export default {"tooltip":"QP-z","arrow":"RP-z"};